import apiClient from 'commons/api/client/apiClient';
import store from 'commons/store/Store';

async function changePassword({ currentPassword, newPassword }) {
  const res = await apiClient.request({
    method: 'POST',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/changePassword`,
    data: {
      currentPassword,
      newPassword,
    },
  });
  return res;
}

async function getMfaStatus() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/mfa/totp/status`,
  });
  return data;
}

async function setupMfa() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/mfa/totp/setup`,
  });
  return data;
}

async function finishMfaSetupAndCreateRecoveryCodes(code) {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/mfa/totp/recovery-codes`,
    data: {
      code,
    },
  });
  return data;
}

async function deleteMfa() {
  const res = await apiClient.request({
    method: 'DELETE',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/mfa/totp/delete`,
  });
  return res;
}

type ChangeEmailData = { email: string };

async function changeEmail({
  newEmail,
  password,
}: {
  newEmail: string;
  password: string;
}): Promise<ChangeEmailData> {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/email`,
    data: {
      newEmail,
      password,
    },
  });

  return data;
}

type ChangeUsernameData = { loginName: string };

async function changeUsername(
  newUsername: string,
): Promise<ChangeUsernameData> {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/api/v1/identities/${store.state.user.data.identity.id}/username`,
    data: {
      newUsername,
    },
  });
  return data;
}

type CurrentIdentityData = {
  email: string;
  username: string;
};

async function getCurrentIdentity(): Promise<CurrentIdentityData> {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/api/v1/identities/current`,
  });
  return data;
}

export default {
  changePassword,
  getMfaStatus,
  setupMfa,
  finishMfaSetupAndCreateRecoveryCodes,
  deleteMfa,
  changeEmail,
  changeUsername,
  getCurrentIdentity,
};
